/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
**********************************************************************/
<template>
  <Tabs :selected="active_tab" @change="(val) => active_tab = val" centered>
    <v-tab class="activeTab" center ripple v-for="tab of tabs" :key="tab.id">
      {{ $t(tab.name) }}
    </v-tab>
    <v-tab-item>
      <Card flat>
        <v-card-text class="pa-0">
          <BlockList :blockData="invLevelData" />
        </v-card-text>
      </Card>
    </v-tab-item>
    <v-tab-item>
      <Card flat>
        <v-card-text class="pa-0">
          <DipReason />
        </v-card-text>
      </Card>
    </v-tab-item>
  </Tabs>
</template>

<script>
import Inverter from '@/services/Inverter'
import {
  mapGettersMixin
} from '@/util/mixin/index'
import {
  mapGetters,
  mapMutations
} from 'vuex'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import {
  EventBus
} from '@/services/event-bus'

const BlockList = () => import('@/components/dashboard-inverter/BlockList')
const DipReason = () => import('@/components/dashboard-inverter/DipReason')
var moment = require('moment')

Vue.use(ElementUI, {
  locale
})

export default {
  components: {
    BlockList,
    DipReason
  },
  mixins: [ mapGettersMixin ],
  data() {
    return {
      invLevelData: [],
      active_tab: 0,
      tabs: [
        { id: 1, name: 'Block List' },
        { id: 2, name: 'Dip Reason' }
      ],
      block_selected: null
    }
  },
  computed: {
    ...mapGetters([
      'getActivePlantInfo',
      'getPlantId',
      'getSelectedPlantId',
      'getGeneralState'
    ]),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    watchChange() {
      return `${this.getSelectedPlantId} ${this.activeFilter.Date.from} ${this.activeFilter.Date.to}`
    }
  },
  created() {
    EventBus.$on('graph-click', this.onManualAlert)
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  beforeDestroy() {
    EventBus.$off('graph-click', this.onManualAlert)
    this.SET_MAP_REDIRECT_BLOCK(false)
  },
  methods: {
    ...mapMutations([
      'SET_PROGRESS_BAR',
      'SET_MAP_REDIRECT_BLOCK',
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getGenerationData()
    },
    async getGenerationData() {
      try {
        this.SET_PROGRESS_BAR(true)
        if (this.getSelectedPlantId && this.activeFilter.Date.from && this.activeFilter.Date.to) {
          let invResponse = await Inverter.fetchInvList(this.getSelectedPlantId, this.activeFilter.Date.from, this.activeFilter.Date.to)
          this.SET_PROGRESS_BAR(false)
          this.invLevelData = invResponse.data.result
        }
        if (this.block_selected == null) {
          this.block_selected = this.invLevelData[0].id
        }
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
    onManualAlert (value) {
      this.active_tab = 1
    }
  },
  watch: {
    watchChange() {
      this.block_selected = null // or NUll
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    block_selected(val) {
      this.$emit('activeBlock', val)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>

  .activeTab:hover {
    background-color: var(--v-sixth-base);
  }

@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.main-background {
  background-color: #2a335a;
}

/*Theme*/
/* .theme--dark .v-card {
  background-color:
  #242c50;
} */
.theme--dark {
  width: -webkit-fill-available;
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .v-card {
    width: 200px !important;
  }
}
</style>
<style>
@media only screen and (min-width: 320px) and (max-width: 960px) {
.ag-energy .v-btn-toggle .v-btn{
  padding: 0px 38px !important;
}
.ag-blockcolor, .ag-energy .v-btn-toggle{
  border-radius: 10px !important;
  border: 1px solid #000 !important;
}
  .ag-sub-header {
    height: 50px !important;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  #daily-updates>.v-card {
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .v-select__selection--comma,
  .v-select .v-label {
    font-size: 13px !important;
  }

  .ag-room, .ag-energy {
    text-align: center;
  }

  .ag-room .v-btn-toggle {
    border: 1px solid;
    border-radius: 10px;
    /* background-color: #FFF !important; */
  }

  .ag-room .v-btn-toggle .v-btn:first-child, .ag-energy .v-btn-toggle .v-btn:first-child{
    border-radius: 8px 0 0 8px;
  }

  .ag-room .v-btn-toggle .v-btn:last-child, .ag-energy .v-btn-toggle .v-btn:last-child{
    border-radius: 0 9px 9px 0;
  }

  .ag-room .v-btn-toggle .v-btn, .ag-energy .v-btn-toggle .v-btn{
    padding: 0px 40px !important;
    /* color: #000 !important; */
  }

  .ag-energy .mt-2{
    border: 8px;
  }

  /* .ag-room .v-btn-toggle .v-btn.v-btn--active, .ag-energy .v-btn-toggle .v-btn.v-btn--active {
    background: linear-gradient(to right, #686DD1, #6C50A4);
    color: #fff !important;
  } */
  .block-content {
    /* background-color: #FFF !important; */
    padding: 16px 10px;
  }

  .theme--dark .activeBlock,
  .block-content .v-list {
    border-radius: 10px !important;
  }

  #e3 .sub-header,
  #e3 {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  /* #e3 .sub-header .v-toolbar__content,
  .ag-block-color,
  .ag-sub-header .v-toolbar__title {
    color: #fff !important;
  } */

  .single-card .hoverable {
    border: none !important;
  }

  .floating-btn {
    margin-top: 30px;
  }

  .ag-picker .v-picker__title .v-date-picker-title,
  .v-date-picker-title {
    /* color: #000 !important; */
    align-items: center !important;
  }

  .activeBlock {
    margin: 10px;
  }

  .notActive {
    margin: 10px;
    border-radius: 10px;
  }

  /* .total-block-gen {
    color: #000 !important;
    background-color: #ffffff !important;
  }

  .ag-blockcolor, .ag-energy .v-btn-toggle {
    background-color: #ffffff !important;
  } */

  .ana-card {
    padding: 20px 12px !important;
  }
}
</style>
